import React from "react";
import cx from "classnames";

import "./style.scss";

const PartialPointList = ({
  points,
  asHeader = "h5",
  isAlignHorizontally = false,
  contentClassNames,
  isDataScroll = false,
}) => {
  return (
    <div
      className={cx("partial-point-list d-flex ", {
        "flex-wrap justify-content-center": isAlignHorizontally,
        "flex-column": !isAlignHorizontally,
      })}
    >
      {points?.map((media, i) => (
        <div
          className={cx("media", {
            "flex-column flex-lg-1 text-center mx-2": isAlignHorizontally,
          })}
          key={i}
          {...(isDataScroll && {
            "data-sal": "slide-up",
            "data-sal-duration": 100,
            "data-sal-easing": "ease-in-quad",
            "data-sal-delay": `${i + 1}00`,
          })}
        >
          <img
            src={media.node.acfPartials.pIcon.localFile.publicURL}
            className={cx("mr-3", {
              "align-self-center mb-2": isAlignHorizontally,
            })}
            alt={media.node.acfPartials.pHeading}
          />
          <div className="media-body">
            <div
              className={`${media.node.acfPartials.pCssClasses} my-3 mx-auto ${asHeader}`}
              dangerouslySetInnerHTML={{
                __html: media.node.acfPartials.pHeading,
              }}
            />
            <div
              className={cx("media-body__content mx-auto", contentClassNames)}
              dangerouslySetInnerHTML={{
                __html: media.node.acfPartials.pContent,
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default PartialPointList;
